import { Route } from 'vue-router'
import store from '../store/'
import { GET_IS_CAPELO, IS_USER_LOGGED_IN } from '@/store/getter-types'
import * as securityService from '@/services/security-service'
import { SecurityArea, SecurityComponent } from '@/types/enums'

export const rootPageGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    next('/dashboard')
  } else {
    next('/login')
  }
}

export const loginPageGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    next('/dashboard')
  } else {
    next()
  }
}

export const isUserLoggedInGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    next()
  } else {
    next('/login')
  }
}

export const dashboardGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showDashboard: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Dashboard)
    showDashboard ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const masterDataGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showMasterData: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Stammdaten)
    showMasterData ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const toolsGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showTools: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Tools)
    showTools ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const settingsGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showSettings: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Settings)
    showSettings ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const printingActivityGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showPrintingActivityGuard: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.PrintingActivity)
    showPrintingActivityGuard ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const addressSearchMultisiteGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showAddressSearchMultisiteGuard: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.MultisiteAddressSearch)
    showAddressSearchMultisiteGuard ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const addressGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showAddress: boolean = securityService.isVisible(SecurityArea.Masterdata, SecurityComponent.Address)
    showAddress ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const commissionsGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showCommissions: boolean = securityService.isVisible(SecurityArea.Masterdata, SecurityComponent.Commission)
    showCommissions ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const productGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showProducts: boolean = securityService.isVisible(SecurityArea.Masterdata, SecurityComponent.Products)
    showProducts ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const dispositionGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showDisposition: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.PersonalDisposition)
    showDisposition ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const projectGuard = (to: Route, from: Route, next: Function): void => {
  const isCapelo = store.getters[GET_IS_CAPELO]
  const showProject: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Projects)

  if (store.getters[IS_USER_LOGGED_IN]) {
    isCapelo && showProject ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const cockpitGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showCockpit: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Cockpit)
    showCockpit ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const recruitingGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showRecruiting: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.Recruiting)
    showRecruiting ? next() : next('/planning')
  } else {
    next('/login')
  }
}

export const ticketingGuard = (to: Route, from: Route, next: Function): void => {
  if (store.getters[IS_USER_LOGGED_IN]) {
    const showCockpit: boolean = securityService.isVisible(SecurityArea.Menu, SecurityComponent.TicketSystem)
    showCockpit ? next() : next('/planning')
  } else {
    next('/login')
  }
}